export default __webpack_public_path__ + "static/media/TransportationCars_00.0458efb1.png";